// After a deploy, old clients still reference webpack/Rspack chunk filenames that
// no longer exist, so React.lazy() dynamic imports reject with a ChunkLoadError.
// A single reload pulls the fresh manifest and fixes it. We guard against reload
// loops (e.g. a genuinely missing chunk) by only reloading once per short window.

const RELOAD_GUARD_KEY = 'chunkReloadAt';
const RELOAD_GUARD_WINDOW = 10000; // ms

const isChunkLoadError = (err) => {
  if (!err) return false;
  if (err.name === 'ChunkLoadError') return true;
  const message = typeof err === 'string' ? err : err.message || '';
  return /Loading (CSS )?chunk [\w-]+ failed/i.test(message) || /error loading dynamically imported module/i.test(message);
};

const reloadOnce = () => {
  try {
    const last = Number(sessionStorage.getItem(RELOAD_GUARD_KEY)) || 0;
    if (Date.now() - last < RELOAD_GUARD_WINDOW) return; // already tried recently — avoid a loop
    sessionStorage.setItem(RELOAD_GUARD_KEY, String(Date.now()));
  } catch {
    // sessionStorage unavailable (private mode) — fall through and reload anyway
  }
  window.location.reload();
};

export const installChunkReloadHandler = () => {
  window.addEventListener('error', (event) => {
    if (isChunkLoadError(event?.error) || isChunkLoadError(event?.message)) reloadOnce();
  });
  window.addEventListener('unhandledrejection', (event) => {
    if (isChunkLoadError(event?.reason)) reloadOnce();
  });
};
